export default __webpack_public_path__ + "static/media/invoices.2ea3f80b.png";